module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('a', {
    staticClass: "brand",
    attrs: {
      "href": _vm.home
    }
  }, [_c('h1', [_vm._v("Idea Mash")])]), _c('div', {
    staticClass: "app-container"
  }, [_c('Idea')], 1), _c('footer', [_c('div', {
    staticClass: "credits-container"
  }, [_c('div', {
    staticClass: "lg-credits"
  }, [_c('p', [_vm._v("Built by "), _c('a', {
    attrs: {
      "href": _vm.mccallLink,
      "target": "_blank"
    }
  }, [_vm._v("McCall Alexander")]), _c('br')]), _c('div', {
    staticClass: "social"
  }, [_c('a', {
    attrs: {
      "href": "https://www.instagram.com/mccallalexander/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.insta
    }
  })]), _c('a', {
    attrs: {
      "href": "https://github.com/mccallofthewild/ideamash/",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.gh
    }
  })]), _c('a', {
    attrs: {
      "href": "https://twitter.com/mccallthetall",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.imgs.twitter
    }
  })])]), _c('p')]), _c('div', {
    staticClass: "sml-credits"
  }, [_c('p', [_vm._v("Credits:")]), _c('span', [_vm._v("fingers crossed cursor:"), _c('a', {
    attrs: {
      "href": _vm.stefanLink,
      "target": "_blank"
    }
  }, [_vm._v(" Stefan Wetterstrand;")])]), _c('span', [_vm._v("twitter logo:"), _c('a', {
    attrs: {
      "href": _vm.audreyLink,
      "target": "_blank"
    }
  }, [_vm._v("Andrey Vasiliev;")])]), _c('span', [_vm._v("favicon:"), _c('a', {
    attrs: {
      "href": _vm.michalLink,
      "target": "_blank"
    }
  }, [_vm._v("Michal Beňo")])]), _c('span', [_c('a', {
    attrs: {
      "href": _vm.nounProjLink,
      "target": "_blank"
    }
  }, [_vm._v("The Noun Project")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7cfd10c2"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 91
// module chunks = 1